import {ReactElement} from 'react';
import LogoutIcon from '@mui/icons-material/Logout';
import {AppBar, Box, IconButton, Link, Stack, Toolbar, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {LOGOUT_URL, USER_GUIDE_URL, VIDEO_TUTORIAL_URL} from 'const/externalLinks';
import LocaleSelector from './components/LocaleSelector';
import icon from './images/icon.svg';

const LOGO_FONT_FAMILY = '"Helvetica Neue", Helvetica, Arial, sans-serif';

export default function PemsaHeader(): ReactElement {
  const {t} = useTranslation('common');

  return (
    <AppBar
      position="static"
      elevation={2}
      sx={{bgcolor: 'background.paper', color: 'text.primary'}}
    >
      <Toolbar sx={{minHeight: 64}}>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            gap: {xs: '5.333px', sm: '6.667px'}
          }}
        >
          <Box
            component="img"
            src={icon}
            alt=""
            sx={{width: {xs: 32, sm: 40}, height: {xs: 32, sm: 40}}}
          />
          <Typography
            component="span"
            sx={{
              fontFamily: LOGO_FONT_FAMILY,
              fontWeight: 700,
              fontSize: {xs: 24, sm: 30},
              lineHeight: 1
            }}
          >
            pemsaPro
          </Typography>
        </Box>
        <Stack direction="row" spacing={2} alignItems="center" useFlexGap>
          <Link
            href={USER_GUIDE_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="body1"
            color="text.primary"
            underline="hover"
            sx={{display: {xs: 'none', sm: 'block'}}}
          >
            {t('common:userGuide')}
          </Link>
          <Link
            href={VIDEO_TUTORIAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="body1"
            color="text.primary"
            underline="hover"
            sx={{display: {xs: 'none', sm: 'block'}}}
          >
            {t('common:videoTutorial')}
          </Link>
          <LocaleSelector />
          <IconButton
            component="a"
            href={LOGOUT_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="logout"
            color="inherit"
            sx={{p: 0.5}}
          >
            <LogoutIcon sx={{fontSize: 20}} />
          </IconButton>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
